import React, { FC, useContext } from 'react';
import Tooltip from 'react-tooltip';
import { injectIntl } from 'react-intl';
import styles from './lawyer_header_top.module.scss';
import { BrokenImageLinkTest } from '../../../../components/BrokenImageLinkTest';
import { Hyperlink } from '../../../../components/Hyperlink';
import {
  withModal,
  WithModalProps,
} from '../../../../components/modal/withModal';
import { ProfessionalPageOwnerModal } from '../../../professional-page-owner-modal/ProfessionalPageOwnerModal';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { UserContext } from '../../../../user/UserContext';
import { VerifyLawyerModal } from '../../../verify-lawyer-modal/VerifyLawyerModal';
import { LawyerContext } from '../../LawyerContext';
import { LawyerModifyPictureWrapper } from './components/LawyerModifyPictureWrapper';
import {
  LawyerPictureEmpty,
  LawyerPicture,
} from './components/LawyerPictureComponents';
import { InjectedIntlProps } from '../../../../doctrine.types';

type Props = WithModalProps & InjectedIntlProps;

export const RawLawyerHeaderTop: FC<Props> = ({ openModal, intl }) => {
  const source = 'professional_picture';
  const { loggedIn, currentUser } = useContext(UserContext);
  const {
    lawyerInfos,
    lawyerHasRetired,
    lawyerIsCurrentUser,
    lawyerIsVerified,
    lawyerImg,
    lawyerName,
  } = useContext(LawyerContext);

  const openProfessionalPageOwnerModal = () => {
    doctrineAnalytics('Professional WantToEdit', {
      source,
    });

    openModal(modalProps => (
      <ProfessionalPageOwnerModal
        source={source}
        name={lawyerName}
        lawyerHasRetired={lawyerHasRetired}
        {...modalProps}
      />
    ));
  };

  const openVerifyLawyerModal = () => {
    doctrineAnalytics('Professional WantToBeVerified', {
      source,
    });

    openModal(modalProps => (
      <VerifyLawyerModal
        lawyerId={lawyerInfos.lawyerId}
        lawyerName={lawyerName}
        {...modalProps}
      />
    ));
  };

  const wantToEdit = () => {
    if (loggedIn) {
      openVerifyLawyerModal();
    } else {
      openProfessionalPageOwnerModal();
    }
  };

  return (
    <BrokenImageLinkTest url={lawyerImg}>
      {isImageLinkBroken => (
        <>
          <div className={styles.container}>
            {(!lawyerImg || isImageLinkBroken) && (
              <>
                {!lawyerIsVerified && !currentUser.verified && (
                  <div onClick={wantToEdit}>
                    <LawyerModifyPictureWrapper canModify={loggedIn}>
                      <LawyerPictureEmpty />
                    </LawyerModifyPictureWrapper>
                  </div>
                )}
                {lawyerIsVerified && loggedIn && lawyerIsCurrentUser && (
                  <Hyperlink href="/profil/informations" source={source}>
                    <LawyerModifyPictureWrapper>
                      <LawyerPictureEmpty />
                    </LawyerModifyPictureWrapper>
                  </Hyperlink>
                )}
                {(lawyerIsVerified || currentUser.verified) &&
                  (!lawyerIsVerified || !loggedIn || !lawyerIsCurrentUser) && (
                    <LawyerPictureEmpty />
                  )}
              </>
            )}
            {lawyerImg && !isImageLinkBroken && (
              <>
                {lawyerIsVerified && loggedIn && lawyerIsCurrentUser && (
                  <Hyperlink href="/profil/informations" source={source}>
                    <LawyerModifyPictureWrapper>
                      <LawyerPicture lawyerImg={lawyerImg} />
                    </LawyerModifyPictureWrapper>
                  </Hyperlink>
                )}
                {(!lawyerIsVerified || !loggedIn || !lawyerIsCurrentUser) &&
                  (lawyerImg ? (
                    <LawyerPicture lawyerImg={lawyerImg} />
                  ) : (
                    <LawyerPictureEmpty />
                  ))}
              </>
            )}
          </div>
          <h1 className="entity__header__title">
            {lawyerName}
            {lawyerIsVerified && (
              <>
                <img
                  src="../../../../../img/icons/entities/verified.svg"
                  alt="verified"
                  data-tip={intl.formatMessage(
                    {
                      id: 'lawyer-header-top/LawyerHeaderTop.tsx/1',
                    },
                    { lawyerName },
                  )}
                  data-for="verified-lawyer-icon"
                  data-place="right"
                  data-effect="solid"
                  className={styles.verifiedIcon}
                />
                <Tooltip id="verified-lawyer-icon" />
              </>
            )}
          </h1>
        </>
      )}
    </BrokenImageLinkTest>
  );
};

export const LawyerHeaderTop = injectIntl(withModal(RawLawyerHeaderTop));
